import { render, staticRenderFns } from "./DeletionWarningDialog.vue?vue&type=template&id=25830a52&scoped=true"
import script from "./DeletionWarningDialog.vue?vue&type=script&lang=js"
export * from "./DeletionWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25830a52",
  null
  
)

export default component.exports